module.exports = __webpack_public_path__ + "static/media/cost-efficiency.ffa90004.svg";